import styles from "@/styles/buying-guide/index.module.scss";
import Head from "next/head";
import { useEffect, useState } from "react";
import DefaultLayout from "@/components/DefaultLayout";
import BreadCrum from "@/components/global/BreadCrum";
import GuideHeader from "@/components/buying-guide/GuideHeader";
import GuidesItem from "@/components/buying-guide/GuidesItem";
import buyingGuidesApi from "@/service/modules/buyingGuidesApi";

export default function BuyingGuidesDetail() {
  interface BreadcrumbItem {
    name: string;
    url: string;
    current: boolean;
  }

  interface PopularBuyingGuidesItem {
    categoryID?: number;
    name: string;
    guideUrl: string;
    detailGuideUrl?: string;
    imgUrl: string;
    seoDescription: string | null;
  }

  const [breadCrumb, setBreadCrumb] = useState<BreadcrumbItem[]>([]);
  const [guideData, setGuideData] = useState<Record<string, any>>({});
  const [popularBuyingGuidesData, setPopularBuyingGuidesData] = useState<PopularBuyingGuidesItem[]>([]);

  // 获取Guide模块数据
  async function getpopularBuyingGuidesData() {
    try {
      let category = new URL(window.location.href).pathname.replace(/^\/|\/$/g, '');
      let resData = await buyingGuidesApi.getBuyingGuides({ category });

      if (resData.data && resData.data && resData.data.guideBox.length) {
        if (resData.data.guideBox && resData.data.guideBox.length) {
          resData.data.guideBox.forEach((item : any) => {
            item.detailGuideUrl = `/${item.guideUrl}`
          })
        }
        setPopularBuyingGuidesData(resData.data.guideBox);
        setGuideData(resData.data.guide);
      }
    } catch (error) {
      console.log(`获取Guide模块数据失败: `, error);
    }
  }

  useEffect(() => {
    getpopularBuyingGuidesData();
  }, []);

  useEffect(() => {
    if (guideData.name) {
      setBreadCrumb([
        {
          name: guideData.name,
          url: `/${guideData.categoryUrl}`,
          current: false,
        },
        {
          name: `${guideData.name} Guides`,
          url: `/${guideData.guideUrl}`,
          current: true,
        },
      ]);
    }
  }, [guideData]);

  return (
    <>
      <Head>
        <title>
          Online Shopping Australia - Beauty & Health, Computers, Toys, - Deals
          & Discounts | CrazySales
        </title>
        <meta
          name="keywords"
          content="Online Shopping Australia, online shopping sites, Home Shopping, Shopping Deals, Best Deals, Home Garden, Pet Supplies, Sports Fitness, Bedding Bath, Buy Online, Discount Shopping, Toys Hobbies, Beauty Health, Crazy Sales, Computers, IT, Christmas, Electronics, Automotive, Tools, Appliances, Baby, CrazySales"
        ></meta>
        <meta
          name="description"
          content="CrazySales.com.au - Australia's #1 online shopping website! Cheap bargains &amp; discounts with the top online shopping Australia store! From furniture, to toys &amp; hobbies, to appliances &amp; pet supplies -- we've got it all, with free shipping on selected items!"
        ></meta>
      </Head>

      <DefaultLayout notStickyNavbar={true}>
        <div className={`${styles["page-buying-guides"]}`}>
          {/* 面包屑 */}
          {!!(breadCrumb && breadCrumb.length) && (
            <BreadCrum BreadList={breadCrumb}></BreadCrum>
          )}

          <div className={styles["content"]}>
            <GuideHeader
              categoryName={guideData.name}
              seoDescription={guideData.seoDescription}
            ></GuideHeader>

            {!!(popularBuyingGuidesData && popularBuyingGuidesData.length) && (
              <div className={styles["guides-list"]}>
                {popularBuyingGuidesData?.map(
                  (product: PopularBuyingGuidesItem, index: number) => (
                    <div className={styles["guides-item"]} key={index}>
                      <GuidesItem
                        type="detail"
                        PopularBuyingGuidesData={product}
                      ></GuidesItem>
                    </div>
                  )
                )}
              </div>
            )}
          </div>
        </div>
      </DefaultLayout>
    </>
  );
}
